'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _authentication = require('./authentication.html');

var _authentication2 = _interopRequireDefault(_authentication);

var _authentication3 = require('./authentication.controller');

var _authentication4 = _interopRequireDefault(_authentication3);

require('./authentication.styl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var authenticationComponent = {
  restrict: 'E',
  bindings: {},
  template: _authentication2.default,
  controller: _authentication4.default,
  controllerAs: 'vm'
};

exports.default = authenticationComponent;


// WEBPACK FOOTER //
// ./client/app/components/authentication/authentication.component.js